<template>
  <div ref="modal" class="modal">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ titleProp }}</p>
        <button
          class="delete"
          aria-label="close"
          @click="close"
          v-if="hasClose"
        ></button>
      </header>
      <section
        :class="{ 'modal-card-body': true, 'has-simplebar': simplebar }"
        :data-simplebar="simplebar"
      >
        <slot></slot>
      </section>
      <footer class="modal-card-foot">
        <button
          :class="secondaryClasses"
          v-if="secondaryProp"
          @click="emit('secondary')"
        >
          {{ secondaryProp }}
        </button>
        <button
          :class="tertiaryClasses"
          v-if="tertiaryProp"
          @click="emit('tertiary')"
        >
          {{ tertiaryProp }}
        </button>
        <button
          :class="primaryClasses"
          v-if="primaryProp"
          @click="emit('primary')"
          :disabled="disabledProp"
        >
          {{ primaryProp }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import "simplebar";

export default {
  props: {
    title: String,
    primary: String,
    secondary: String,
    tertiary: String,
    id: String,
    simplebar: Boolean,
    type: {
      type: String,
      default: "normal",
    },
    disabled: Boolean,
    hasClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      titleProp: null,
      primaryProp: null,
      secondaryProp: null,
      tertiaryProp: null,
      disabledProp: false,
      isLoading: false,
    };
  },

  computed: {
    primaryClasses() {
      return {
        button: true,
        "is-primary": this.typeProp === "normal",
        "is-danger": this.typeProp === "danger",
        "is-light": this.typeProp === "neutral",
        "is-green": this.typeProp === "green",
        "is-medium": true,
        "is-loading": this.isLoading,
      };
    },
    secondaryClasses() {
      return {
        button: true,
        "is-text": true,
        "is-loading": this.isLoading,
      };
    },
    tertiaryClasses() {
      return {
        button: true,
        "is-text": true,
        "is-loading": this.isLoading,
      };
    },
  },

  created() {
    this.titleProp = this.title;
    this.primaryProp = this.primary;
    this.secondaryProp = this.secondary;
    this.tertiaryProp = this.tertiary;

    this.typeProp = this.type;

    window.addEventListener("keyup", (e) => {
      if ((e.keyCode || e.which) === 27) {
        this.close();
      }
    });
  },
  methods: {
    open() {
      if (this.$refs.modal) {
        this.$refs.modal.classList.add("is-active");
        if (this.id) {
          this.$root.$emit(this.id + "-start");
        }
      }
    },
    close() {
      if (this.$refs.modal) {
        this.$refs.modal.classList.remove("is-active");

        if (this.id) {
          this.$root.$emit(this.id + "-end");
        }
      }
    },

    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },

    setProps(options) {
      if (typeof options.title !== "undefined") {
        this.titleProp = options.title;
      }

      if (typeof options.type !== "undefined") {
        this.typeProp = options.type;
      }

      if (typeof options.disabled !== "undefined") {
        this.disabledProp = options.disabled;
      }

      if (options.labels && typeof options.labels.primary !== "undefined") {
        this.primaryProp = options.labels.primary;
      }

      if (options.labels && typeof options.labels.secondary !== "undefined") {
        this.secondaryProp = options.labels.secondary;
      }

      if (options.labels && typeof options.labels.tertiary !== "undefined") {
        this.tertiaryProp = options.labels.tertiary;
      }
    },

    scrollTop() {
      //document.querySelector('section').scrollTop = 0
    },

    emit(value) {
      this.$emit(value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/variables";
@import "~simplebar/dist/simplebar.css";

.modal.is-medium {
  .modal-card {
    min-width: 320px;
    max-width: 640px;
    width: 100%;
  }
}

.modal.is-large {
  .modal-card {
    width: 800px;
  }
}

// remover e usar as variaveis do bulma
.modal-card-head,
.modal-card-body,
.modal-card-foot {
  background-color: $grey-darker;
  border: none;
}

.modal-card-head,
.modal-card-foot {
  display: flex;
  text-align: center;
  justify-content: center;
  border-radius: 0;
  padding: 1.75rem;
}

.modal-card-head {
  padding-bottom: 1.35rem;
}

.modal-card-foot {
  padding: 1.75rem 3rem;
}

.modal-card-body {
  padding: 0 3rem;

  * {
    color: $white;
  }
}

.modal-card-body.has-simplebar {
  padding: 0;
}

.modal-card-title {
  color: $white;
  font-size: $size-6;
}

.delete {
  height: 32px;
  width: 32px;
  max-height: 32px;
  max-width: 32px;
  background-color: transparent;
  opacity: 0.5;
  transition: 0.2s all;

  &:hover {
    opacity: 1;
    background-color: transparent;
    transform: scale(1.2);
  }

  position: absolute;
  right: 20px;
}

.button.is-green {
  color: #fff;
  background-color: #7ed321;
  border: none;
}

// Form
.form {
  border: none;
  padding: 1.6rem 2rem 2rem;
  background-color: $black;
  //border-left: 2px $primary solid;

  @each $city, $map in $cities {
    .is-#{$city} & {
      border-left: 2px map-get($map, "primary") solid;
    }
  }
}
</style>
